import React, { useState, useEffect } from 'react';
import { toInteger } from 'lodash';


import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { BsBuilding } from "react-icons/bs";

import Page from 'src/components/Page';
import agm from '../../services/agm';

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import Upload from '../documents/Upload';

import Document from './Document';
import Results from './Results';
import Toolbar from './Toolbar';
import Create from './Create';
import Unit from './Unit';
import Infra from './Infra';
import CreateInfra from './CreateInfra';
import View from './View';



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  id: null,
  codigo: null,
  nome: null,
  ENGENHEIRO: null,
  EQUIPE: null,
  REGIAO: null,
  gso: null,
  cnpj: null,
  endereco: null,
  bairro: null,
  cep: null,
  telefone: null,
  empresa: null,
  latitude: null,
  longitude: null,
  obs: null,
  gerenciadora: null,
  fiscal: null,
  municipio: null,
  uf: null,
  tipo: null,
  ativa: true,
  TIPO: null,
  MUNICIPIO: null,
  GERENCIADORA: null
};

const defaultDependencies = {
  loaded: false,
  types: [],
  engineers: [],
  controllers: [],
  companies: [],
  teams: [],
  regions: [],
  managers: [],
  states: [],
  cyties: [],
  infras: [],
  infrasUnidade: [],
  contracts: [],
  documents: [],
  equipments: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: [],
  states: [],
  cyties: [],
  teams: [],
  regions: []
}

const defaultInfra = {
  id: null,
  nome: "",
  tipo: {},
  TIPO: null,
  valores: [],
  docs: []
}

const defaultInfraValues = {

}

const defaultUploadState = [];

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;


const defaultResultColumns = [
  { name: 'Código', field: 'item.codigo', size: -1, sortable: 'codigo', exportable: 1, wrap: 0 },
  { name: 'Nome', field: 'item.nome', size: -1, sortable: 'nome', exportable: 1, wrap: 0 },
  { name: 'Tipo', field: '(item.tipo) ? item.tipo.nome : "Não Informado"', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Município', field: '(item.municipio) ? item.municipio.nome : ""', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'UF', field: '(item.municipio) ? item.municipio.uf : ""', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Endereço', field: 'truncateValue(item.endereco, 35)', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Bairro', field: 'item.bairro', size: -1, sortable: 'bairro', exportable: 1, wrap: 0 },
  { name: 'Rota', field: '(item.regiao) ? item.regiao.nome : ""', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Equipe', field: '(item.equipe) ?  item.equipe.nome : ""', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Situação', field: '(item.ativa) ? ("Ativa") : ("Inativa")', size: -1, sortable: 0, exportable: 1, wrap: 0 },
  { name: 'Posição no Mapa', field: '(item.latitude || item.longitude) ? ("(" + item.latitude + ", " + item.longitude + ")") : "(0,0)"', size: -1, sortable: 0, exportable: 0, wrap: 0 }
];

const defaultEmptyMessage = "Nenhuma Unidade Foi Encontrada.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_ENABLED,
  view: LEVEL_ACCESS_ENABLED,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Unidades pelo Código', refine: 1, label: 'Centro de Custo da Unidade', history: 0 },
  { id: 3, name: 'Unidades pelo Nome', refine: 3, label: 'Nome da Unidade', history: 0 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0],
  apontados: 0,
  uf: -1,
  municipios: [],
  equipes: [],
  regioes: []
}

const Units = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadState, setUploadState] = useState(defaultUploadState);
  const [document, setDocument] = useState({});
  const [openDeletionDocumentDialog, setOpenDeletionDocumentDialog] = useState(false);
  const [openDocumentEditionDialog, setOpenDocumentEditionDialog] = useState(false);
  const [checkedContracts, setCheckedContracts] = useState([]);
  const [infra, setInfra] = useState(defaultInfra);
  const [openDeletionInfraDialog, setOpenDeletionInfraDialog] = useState(false);
  const [openInfraEditionDialog, setOpenInfraEditionDialog] = useState(false);
  const [openInfraCreationDialog, setOpenInfraCreationDialog] = useState(false);
  const [checkedInfras, setCheckedInfras] = useState([]);
  const [infraDocument, setInfraDocument] = useState(null);
  const [openDeletionDocumentInfraDialog, setOpenDeletionDocumentInfraDialog] = useState(false);
  const [openDocumentInfraEditionDialog, setOpenDocumentInfraEditionDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);

  const [infoValues, setInfoValues] = useState([]);

  const [state, setState] = useState(defaultState);


  const openView = (item) => {
    setOpenViewDialog(true);
  }

  const changeValues = (values) => {

  }

  const openExportDialog = async (format) => {
    await agm.post('/unidades/export', {
      format: format,
      filtro: filter,
      colunas: defaultResultColumns
    }, {}).then(async (response) => {
      setMessage(response.data);
      setOpenAlert(true);
      const link = window.document.createElement('a');
      var url = process.env.REACT_APP_AGM_ENDPPOINT + '/exports/unidades.xlsx';
      link.setAttribute('download', 'unidades.xlsx');
      link.href = url;
      window.document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openEdition = async (item) => {
    setItem(item);
    if (item.municipio) {
      item = { ...item, uf: item.municipio.uf };
    }
    var uf = (item.uf) ? item.uf : null;
    var empresa = (item.empresa) ? item.empresa : null;
    var equipe = (item.EQUIPE) ? item.EQUIPE : null;
    await agm.get('/unidades/edicao/' + item.id + "," + uf + "," + empresa + ',' + equipe, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            types: response.data.tipos,
            engineers: response.data.engenheiros,
            controllers: response.data.gerenciadoras,
            companies: response.data.empresas,
            teams: response.data.equipes,
            regions: response.data.regioes,
            managers: response.data.gerentes,
            states: response.data.estados,
            cyties: response.data.municipios,
            infras: response.data.infraestruturas,
            infrasUnidade: response.data.infraestruturasSelecionadas,
            contracts: response.data.contratos,
            documents: response.data.documentos,
            equipments: response.data.equipamentos
          }
        );
        var checked = [];
        response.data.contratosSelecionados.forEach(element => {
          checked.push(element.contrato);
        });
        setCheckedContracts(checked);
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: 'Erro ao gerar o arquivo. ' + error.message });
      setOpenAlert(true);
    });
  }

  const openCreation = async (item) => {
    setItem(item);
    if (item.municipio) {
      item = { ...item, uf: item.municipio.uf };
    }
    var uf = (item.uf) ? item.uf : null;
    var empresa = (item.empresa) ? item.empresa : null;
    var equipe = (item.EQUIPE) ? item.EQUIPE : null;
    await agm.get('/unidades/edicao/' + item.id + "," + uf + "," + empresa + ',' + equipe, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            types: response.data.tipos,
            engineers: response.data.engenheiros,
            controllers: response.data.gerenciadoras,
            companies: response.data.empresas,
            teams: response.data.equipes,
            regions: response.data.regioes,
            managers: response.data.gerentes,
            states: response.data.estados,
            cyties: response.data.municipios,
            infras: response.data.infraestruturas,
            infrasUnidade: response.data.infraestruturasSelecionadas,
            contracts: response.data.contratos,
            documents: response.data.documentos,
            equipments: response.data.equipamentos
          }
        );
        var checked = [];
        response.data.contratosSelecionados.forEach(element => {
          checked.push(element.contrato);
        });
        setCheckedContracts(checked);
        setItem(item);
        setOpenCreationDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Unidades',
      message: 'Deseja excluir a unidade selecionada?',
      warn: 'Esta ação irá apagar todos os dados da unidade.'
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = async (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeView = () => {
    setOpenViewDialog(false);
  };

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const updateTreatmentValues = async (values, statusHistory) => {

  }

  const updateValues = (values) => {
    agm.put('/unidades/' + values.id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    agm.post('/unidades', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const deleteValues = (values) => {
    agm.delete('/unidades/' + values.id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    agm.post('/unidades/historico', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows,
          states: response.data.ufs,
          cyties: response.data.municipios,
          teams: response.data.equipes,
          regions: response.data.regioes
        });
      } else {
        setState(defaultState);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post('/unidades/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows,
          states: response.data.ufs,
          cyties: response.data.municipios,
          teams: response.data.equipes,
          regions: response.data.regioes
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (vision, keyword, page, rows, pointed, state, cyties, teams, regions) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      palavrachave: keyword,
      visao: vision,
      apontados: pointed,
      uf: state,
      municipios: cyties,
      equipes: teams,
      regioes: regions
    };
    setVision(vision);
    setFilter(value);
    agm.post('/unidades/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows,
          states: response.data.ufs,
          cyties: response.data.municipios,
          teams: response.data.equipes,
          regions: response.data.regioes
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  const openDocumentInfraEdition = (item) => {
    setInfraDocument(item);
    setOpenDocumentInfraEditionDialog(true);
  }

  const openDocumentEdition = (item) => {
    setDocument(item);
    setOpenDocumentEditionDialog(true);
  }

  const closeDocumentInfraEdition = () => {
    setOpenDocumentInfraEditionDialog(false);
  }

  const closeDocumentEdition = () => {
    setOpenDocumentEditionDialog(false);
  }

  const closeDeletionDocument = () => {
    setOpenDeletionDocumentDialog(false);
  }

  const closeDeletionInfra = () => {
    setOpenDeletionInfraDialog(false);
  }

  const closeDeletionDocumentInfra = () => {
    setOpenDeletionDocumentInfraDialog(false);
  }

  const openDeletionDocument = (item) => {
    setDocument(item);
    setMessage({
      title: 'Documento',
      message: 'Deseja excluir o documento "' + item.nome + '"?',
      warn: 'Esta ação irá remover o documento do local de armazenamento e o arquivo não poderá mais ser recuperado.'
    });
    setOpenDeletionDocumentDialog(true);
  }

  const fileSize = (bytes) => {
    var exp = Math.log(bytes) / Math.log(1024) | 0;
    var result = (bytes / Math.pow(1024, exp)).toFixed(2);
    return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
  }

  const onUpload = (files) => {
    var selectedFiles = files.map(file => ({
      id: file.name,
      name: file.name,
      readableSize: fileSize(file.size),
      uploaded: false,
      preview: URL.createObjectURL(file),
      file,
      progress: 0,
      error: false,
      url: ""
    }));
    setUploadState(selectedFiles);
    selectedFiles.forEach(processUpload);
  }

  const updateFile = ((id, data) => {
    setUploadState((state) =>
      state.map((file) => (file.id === id ? { ...file, ...data } : file))
    );
  });

  const processUpload = ((uploadedFile) => {
    const data = new FormData();
    data.append('unidade', item.id);
    data.append('infraestrutura', (infra.id) ? infra.id : null);
    data.append("file", uploadedFile.file);
    agm.post("/documentosunidade/arquivar", data, {
      unidade: item.id, infraestrutura: (infra.id) ? infra.id : null,
      onUploadProgress: (progressEvent) => {
        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        updateFile(uploadedFile.id, { progress });
      },
    })
      .then((response) => {
        if (!response.data.error) {
          updateFile(uploadedFile.id, {
            uploaded: true,
            id: response.data._id,
            url: response.data.url,
          });
        } else {
          console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor`);
          updateFile(uploadedFile.id, { error: true });
        }
      })
      .catch((err) => {
        console.error(`Houve um problema ao fazer upload do arquivo ${uploadedFile.name} no servidor`);
        updateFile(uploadedFile.id, { error: true });
      });
  });

  const closeUpload = () => {
    setOpenUploadDialog(false);
    updateDocuments(item, dependencies);
    if (infra.id) {
      agm.get('/unidades/infra/' + infra.id, {}, {}).then((response) => {
        if (!response.data.error) {
          setInfra(response.data);
        } else {
          setState(defaultState);
          setMessage(response.data);
          setOpenAlert(true);
        }
      }).catch((error) => {
        console.error(error);
        setMessage({ error: true, fatal: true, message: error.message });
        setOpenAlert(true);
      })
    }
  };

  const openUpload = (values) => {
    setItem(values);
    setUploadState(defaultUploadState);
    setOpenUploadDialog(true);
  };

  const openUploadInfra = (values) => {
    setInfra(values);
    setUploadState(defaultUploadState);
    setOpenUploadDialog(true);
  };

  const updateDocumentInfraValues = (values) => {
    agm.put('/documentosunidade/' + values.id, values).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        openInfraEdition(infra);
        closeDocumentInfraEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const updateDocumentValues = (values) => {
    agm.put('/documentosunidade/' + values.id, values).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        closeDocumentEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const updateDocuments = async (values, dependencies) => {
    setItem(values);
    if (values.municipio) {
      values = { ...values, uf: values.municipio.uf };
    }
    var uf = (values.uf) ? values.uf : null;
    var empresa = (values.empresa) ? values.empresa : null;
    var equipe = (values.EQUIPE) ? values.EQUIPE : null;
    await agm.get('/unidades/edicao/' + values.id + "," + uf + "," + empresa + ',' + equipe, {}, {}).then((response) => {
      if (!response.data.error) {
        dependencies = {
          types: response.data.tipos,
          engineers: response.data.engenheiros,
          controllers: response.data.gerenciadoras,
          companies: response.data.empresas,
          teams: response.data.equipes,
          regions: response.data.regioes,
          managers: response.data.gerentes,
          states: response.data.estados,
          cyties: response.data.municipios,
          infras: response.data.infraestruturas,
          infrasUnidade: response.data.infraestruturasSelecionadas,
          contracts: response.data.contratos,
          documents: response.data.documentos,
          equipments: response.data.equipamentos
        };
        setDependencies(dependencies);
        var checked = [];
        response.data.contratosSelecionados.forEach(element => {
          checked.push(element.contrato);
        });
        setCheckedContracts(checked);
        setItem(values);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateDependencies = async (values) => {
    var uf = (values.uf) ? values.uf : null;
    var empresa = (values.empresa) ? values.empresa : null;
    var equipe = (values.EQUIPE) ? values.EQUIPE : null;
    await agm.get('/unidades/edicao/' + item.id + "," + uf + "," + empresa + ',' + equipe, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            types: response.data.tipos,
            engineers: response.data.engenheiros,
            controllers: response.data.gerenciadoras,
            companies: response.data.empresas,
            teams: response.data.equipes,
            regions: response.data.regioes,
            managers: response.data.gerentes,
            states: response.data.estados,
            cyties: response.data.municipios,
            infras: response.data.infraestruturas,
            infrasUnidade: response.data.infraestruturasSelecionadas,
            contracts: response.data.contratos,
            documents: response.data.documentos,
            equipments: response.data.equipamentos
          }
        );
        var checked = [];
        response.data.contratosSelecionados.forEach(element => {
          checked.push(element.contrato);
        });
        setCheckedContracts(checked);
        setItem(values);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const openDeletionInfra = (item) => {
    setInfra(item);
    setMessage({
      title: 'Infraestrutura de Unidade',
      message: 'Deseja excluir a infraestrutura da unidade selecionada?',
      warn: 'Esta ação irá apagar dados que não poderão ser recuperados.'
    });
    setOpenDeletionInfraDialog(true);
  }

  const openDeleteDocumentInfra = (item) => {
    setInfraDocument(item);
    setMessage({
      title: 'Documento',
      message: 'Deseja excluir o documento "' + item.nome + '"?',
      warn: 'Esta ação irá remover o documento do local de armazenamento e o arquivo não poderá mais ser recuperado.'
    });
    setOpenDeletionDocumentInfraDialog(true);
  }

  const deleteInfra = (values) => {
    agm.delete('/unidades/infra/' + values.id).then((response) => {
      if (!response.data.error) {
        for (let index = 0; index < dependencies.infrasUnidade.length; index++) {
          const element = dependencies.infrasUnidade[index];
          if (element.id == values.id) {
            dependencies.infrasUnidade.splice(index, 1);
            break;
          }
        }
      }
      closeDeletionInfra();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      closeDeletionInfra();
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const handleToggle = (value, set) => () => {
    if (set == 'contracts') {
      const currentIndex = checkedContracts.indexOf(value);
      const newChecked = [...checkedContracts];
      if (currentIndex == -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      var data = {
        value: value,
        action: (newChecked.length > checkedContracts.length) ? 1 : 0
      }
      agm.put('/unidades/contrato/' + item.id, data).then((response) => {
        if (!response.data.error) {
          setCheckedContracts(newChecked);
        }
        setMessage(response.data);
        setOpenAlert(true);
      }).catch((error) => {
        console.error(error);
        setMessage({ error: true, info: true, message: error.message });
        setOpenAlert(true);
      })
    }
    if (set == 'infras') {
      const currentIndex = checkedInfras.indexOf(value);
      const newChecked = [...checkedInfras];
      if (currentIndex == -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setCheckedInfras(newChecked);
    }
  };

  const deleteDocument = (values) => {
    agm.delete('/documentosunidade/' + values.id).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        closeDeletionDocument();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };

  const deleteDocumentInfra = (values) => {
    agm.delete('/documentosunidade/' + values.id).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        openInfraEdition(infra)
        closeDeletionDocumentInfra();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  };


  const openInfraEdition = (infra) => {
    agm.get('/unidades/infra/' + infra.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setInfra(response.data);
        setInfoValues(response.data.valores);
        setInfraDocument(null);
        setOpenInfraEditionDialog(true);
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const changeItem = (value, index, type) => {
    let vlrs = [...infoValues];
    if (type == 4) {
      vlrs[index].DATA = value;
      vlrs[index].VALOR = null;
    } else {
      vlrs[index].VALOR = value;
      vlrs[index].DATA = null;
    }
    vlrs[index].ALTERADO = 1;
    setInfoValues(vlrs);
  }

  const openInfraCreation = (values) => {
    setCheckedInfras([]);
    setOpenInfraCreationDialog(true);
  }

  const createInfraValues = (values) => {
    agm.post('/unidades/infra', { unidade: item.id, infras: checkedInfras }).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        closeInfraCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const updateInfraValues = (values) => {
    var iteminfra = {
      qtd: values.qtd,
      detalhes: values.detalhes,
      valores: infoValues
    }
    agm.put('/unidades/infra/' + values.id, { unidade: item.id, infraestrutura: iteminfra }).then((response) => {
      if (!response.data.error) {
        updateDocuments(item, dependencies);
        closeInfraEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const closeInfraEdition = () => {
    setInfra(defaultInfra);
    setOpenInfraEditionDialog(false);
  }

  const closeInfraCreation = () => {
    setOpenInfraCreationDialog(false);
  }

  const changeDocumentInfra = (values) => {
    setInfraDocument(values);
  }

  return (
    <Page
      className={classes.root}
      title="Unidades"
    >

      <Container maxWidth={false}>

        <Toolbar
          icon={BsBuilding}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
          openView={openView}
        />

        <Confirmations item={document}
          message={message}
          open={openDeletionDocumentDialog}
          close={closeDeletionDocument}
          confirmation={deleteDocument} />

        <Confirmations item={infra}
          message={message}
          open={openDeletionInfraDialog}
          close={closeDeletionInfra}
          confirmation={deleteInfra} />

        <Confirmations item={infraDocument}
          message={message}
          open={openDeletionDocumentInfraDialog}
          close={closeDeletionDocumentInfra}
          confirmation={deleteDocumentInfra} />

        <Document item={document}
          closeEdition={closeDocumentEdition}
          updateValues={updateDocumentValues}
          open={openDocumentEditionDialog}
        />

        <Document item={infraDocument}
          closeEdition={closeDocumentInfraEdition}
          updateValues={updateDocumentInfraValues}
          open={openDocumentInfraEditionDialog}
        />

        <Upload item={item}
          uploadState={uploadState}
          onUpload={onUpload}
          close={closeUpload}
          open={openUploadDialog}
          destinationTitle={"Enviar Documentos para Unidade"} />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations
          item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Unit item={item}
          selectedMode={selectedMode}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          openUpload={openUpload}
          openDocumentEdition={openDocumentEdition}
          updateDocuments={updateDocuments}
          openDeletionDocument={openDeletionDocument}
          updateDependencies={updateDependencies}
          openDeletionInfra={openDeletionInfra}
          openInfraEdition={openInfraEdition}
          openInfraCreation={openInfraCreation}
          checked={checkedContracts}
          handleToggle={handleToggle}
        />

        <Create
          item={item}
          open={openCreationDialog}
          closeCreation={closeCreation}
          createValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Infra item={infra}
          open={openInfraEditionDialog}
          closeEdition={closeInfraEdition}
          updateValues={updateInfraValues}
          dependencies={dependencies}
          openUpload={openUploadInfra}
          openDocumentEdition={openDocumentInfraEdition}
          updateDependencies={updateDependencies}
          selectedMode={selectedMode}
          infraDocument={infraDocument}
          changeDocumentInfra={changeDocumentInfra}
          openDeletion={openDeleteDocumentInfra}
          infoValues={infoValues}
          changeItem={changeItem}
        />

        <CreateInfra item={defaultInfra}
          open={openInfraCreationDialog}
          closeCreation={closeInfraCreation}
          createValues={createInfraValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          checked={checkedInfras}
          handleToggle={handleToggle}
        />

        <View resultSet={state}
          open={openViewDialog}
          closeView={closeView}
          changeValues={changeValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={BsBuilding}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Page>
  );
};

export default Units;
